export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* NAVIGATION */
    $('.ginput_recaptcha').each(function(i)
    {
    var thisID = $(this).attr('id');
    $(this).attr('id', thisID+'_'+i);
    });

    //add menu arrows to desktop nav dropdown
    var sub_nav_items = $('.sub-menu li a');
    sub_nav_items.each(function(){
      var element = '<a href="' + this.href + '" class="desktop desktop-sub-arrow"><img src="/wp-content/themes/keystone/dist/images/button_arrow_orange.svg" /></a>';
      $(this).after(element);
    });

    //Toggle mobile menu

    $('#mobile-hamburger').click(function(){
      $(this).toggleClass('active');
      $('.mobile-menu-flyout').toggleClass('active');
      $('html, body').toggleClass('screen-lock');
    });

    //mobile hamburger animations
    $('#mobile-hamburger').click(function(){
      $(this).toggleClass('open');
    });

    //add menu links to mobile nav
    var mobile_nav_items = $('.mobile-nav .menu li a');
    mobile_nav_items.each(function(){
      var element = '<a class="mobile-nav-arrow-button" href="' + this.href + '"><img src="/wp-content/themes/keystone/dist/images/mobile_nav_arrow.svg" /></a>';
      $(this).not('.desktop-sub-arrow').after(element);
    });

    //add carats to denote nav items with submenus
    var nav_has_kids = $('.mobile-nav .menu-item-has-children')
    nav_has_kids.each(function(){
      var element = '<img class="has-children-image" src="/wp-content/themes/keystone/dist/images/mobile_nav_submenu_arrow.svg">';
      $(this).find('a').not('.mobile-nav-arrow-button').before(element);
    });

    //remove link from mobile nav items with children, toggle subnav
    if($(window).width() < 900 ){
      $('.menu-item-has-children a').not('.mobile-nav-arrow-button, .sub-menu a').click(function(event){
        event.preventDefault();
        var next_submenu = $(this).closest('.menu-item-has-children').find('.sub-menu');
        // $('.has-children-image').not($(this).prev('.has-children-image')).removeClass('rotate');
        $(this).prev('.has-children-image').toggleClass('rotate');
        next_submenu.slideToggle();
      });
    }

    //remove click event from menu items with class no-click
    if($(window).width() > 900) {
      $('.no-click a').not('.no-click .sub-menu a').click(function(e){
        e.preventDefault();
      });  
    }

    /* LEADERSHIP LIGHTBOX */
    $('.leader .headshot, .leader .button').click(function(event){
      event.preventDefault();
      $(this).closest('section').find('.leadership-lightbox-container').addClass('active');
      $('html, body').css('overflow', 'hidden');
      var leader_selected_id = '#leadership-lightbox-' + $(this).closest('.leader').data('leader-number');
      $(leader_selected_id).addClass('active');
    });

    $('.lightbox-close').click(function(){
      $('.leadership-lightbox-container').removeClass('active');
      $('.leadership-lightbox').removeClass('active');
      $('html, body').css('overflow', 'auto');
    });

    /* HERO ANIMATION FOR CAREERS AND WHY KEYSTONE PAGES */
    $(window).on('load', function(){
      console.log('testing');
      $('.image-column').addClass('animate');
    });

    /* REPLACE FILE UPLOAD BUTTON */
    // var file_submit_button = '<img class="file_upload_button" style="cursor: pointer;" src="/wp-content/themes/keystone/dist/images/file_upload_button.svg" />';
    // $('#gform_2 .ginput_container_fileupload').after(file_submit_button);

    /* TOGGLE CAREERS ACCORDION */
    $('.opportunity-header').click(function(){
      $(this).next('.opportunity-body').slideToggle();
      $(this).find('.circle-plus').toggleClass('opened');
    });

    /* CONTACT FORM POPUP LIGHTBOX */
    $('.contact-form.menu-item a').click(function(e) {
      e.preventDefault();
      $('.contact-lightbox').addClass('active');
      $('.contact-lightbox').addClass('contactHeader');
    });

    $('.header-request').click(function(e) {
      e.preventDefault();
      $('.contact-lightbox').addClass('active');
      $('.contact-lightbox').addClass('assessmentHeader');
    });

    $('.header-login').click(function(e) {
      e.preventDefault();
      $('.login-lightbox').addClass('active');
      $('.login-lightbox').addClass('login');
    });

    $('.cf-lightbox-close').click(function(){
      $('.contact-lightbox').removeClass('active');
      $('.login-lightbox').removeClass('active');
      $('.gated-lightbox').removeClass('active');
      $('.contact-lightbox').removeClass('contactHeader');
      $('.contact-lightbox').removeClass('assessmentHeader');
    });

    if (window.location.href.indexOf('/#contact-us-popup') > -1) {
      $('.contact-lightbox').addClass('active');
      $('.contact-lightbox').addClass('contactHeader');
    }

    /* eslint-disable */
    $('.button._open_gated').click(function(e) {
      let _gated_lightbox = $('.gated-lightbox');
      if(!_gated_lightbox.hasClass('active')) { _gated_lightbox.addClass('active'); }
      $('#input_7_9').val($(this).attr('data-gated_redirect_identifier'));
    })
    /* eslint-enable */
    

    //Populate Careers Hidden Fields
    // var position = $('#field_6_2 input').closest('.position');
    // var location = $('.job-location').text();

    // console.log(position);
    // console.log(location);

    // $('#input_6_2').val(this.closest('.position'));
    // $('#input_6_3').val($(this).closest('.location'));

    // $('#field_2_2').val(this.closest('.position'));
    // $('#field_2_3').val(this.closest('.location'));
    // start of rollworks lp
  
  /* start of home */
//   var sections = document.querySelectorAll('.observe-section');
//   var sectionNav = document.querySelector('.section-nav');
//   sections.forEach(function(section){
//     sectionNav.insertAdjacentHTML('beforeend','<a id="nav-'+ section.id +'" href="#' + section.id + '" class="section-nav-circle"></a>');
//   });

//   let options = {
//     root: document.querySelector('#scrollArea'),
//     rootMargin: '100px',
//     threshold: .8,
//   }
//   var observer = new IntersectionObserver ((entries) => {
//     entries.forEach(function(entry){
//       var element_id = '#nav-' + entry.target.id;
//       var current_element = document.querySelector(element_id);
//       var sectionNavCircles = document.querySelectorAll('.section-nav-circle');
//       if(entry.isIntersecting === true) {
//         sectionNavCircles.forEach(function(sectionNavCircle){
//           sectionNavCircle.style.cssText = 'background: #fff; width: 8px; height: 8px;';
//         }); 
//         current_element.style.cssText = 'background: #FFA400; width: 12px; height: 12px;';
//         $('.home-line-items').removeClass('animate');
//         if(entry.target.id == 'home-line-items') {
//           $('.home-line-items').addClass('animate');
//         }
//         $('.home-arch').removeClass('animate');
//         if(entry.target.id == 'home-arch') {
//           $('.home-arch').addClass('animate');
//           setTimeout(function() {
//             $('.home-arch').css('pointer-events','all');
//           }, 2000)
//         }
//       }
//       // console.log(entry);
//       // console.log(element_id);
//       // console.log(current_element);
//     });
//   }, options);
//   $(window).on('load', function() {
//     //add video to lightbox
//     var video = '<iframe width="1120" height="630" src="https://www.youtube.com/embed/OlcYORQNozg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
//     $('.video-lightbox').append(video);
//   });

//   $(window).load(function(){

//     //initialize intersection observer
//     sections.forEach(function(section){
//       observer.observe(section);
//     });

//     //scroll to next section arrows
//     $('.more-arrow').each(function(){
//       var next_section = $(this).closest('section').next('section');
//       if(next_section.css('display') != 'none') {
//         var id_selector = '#' + $(this).closest('section').next('section').attr('id');
//         $(this).attr('href', id_selector);
//       }
//     });

//     //hover button width hack
//     $('.bottom-left-button .blurb').width($('.bottom-left-button .main').width() + $('.bottom-left-button .sub').width() );
//     $('.bottom-right-button .blurb').width($('.bottom-right-button .main').width() + $('.bottom-right-button .sub').width() );

//     //video lightbox
//     $('.video-popup').click(function(){
//       $('.video-lightbox').addClass('active');
//       $('html, body').css('overflow', 'hidden');
//     });

//     $('.video-lightbox-close').click(function() {
//       $('.video-lightbox').removeClass('active');
//       $('html, body').css('overflow', 'unset');
//     });
//   });

//   //arch
//   $('.arch-item').click(function(){
//     $('.arch-container').addClass('selected');
//     $('.centerer').addClass('selected');
//     //remove text
//     $('.arch-text').slideUp();
//     //remove other arches
//     // $('.arch-item').addClass('fade-out');
//     // //don't remove the arch we just selected
//     // $(this).removeClass('fade-out');
//     // add this class to prevent hover blinking
//     $('.arch-item').removeClass('active');
//     $(this).addClass('active');
//     // //fade out the main container after initial animation
//     // setTimeout(function() {
//     //   $('.arch-container').addClass('fade-out');
//     // }, 1500);
//     //fade in the selected container after everything
//     var selected_class = $(this).attr('class');

//     //first arch is selected
//     if(selected_class.includes('arch-1')) {
//       // setTimeout(function() {
//       //   $('.arch-item').removeClass('fade-out active');
//       //   $('#hospital-arch-container').addClass('fade-in');
//       //   //hide all other arch containers
//       // }, 3000);
//       // setTimeout(function(){
//       //   $('.arch-container').addClass('hidden');
//       //   $('.arch-container').removeClass('fade-out');
//       //   $('#hospital-arch-container').removeClass('hidden fade-in fade-out');
//       //   $('#hospital-arch-text').slideToggle();
//       // }, 4500);
//       setTimeout(function() {
//         console.log('slide toggle--common.js');
//         $('#hospital-arch-text').slideToggle();
//       }, 500);
//     }

//     //second arch is selected
//     if(selected_class.includes('arch-2')) {
//       // setTimeout(function() {
//       //   $('.arch-item').removeClass('fade-out active');
//       //   $('#physician-arch-container').addClass('fade-in');
//       //   //hide all other arch containers
//       // }, 3000);
//       // setTimeout(function(){
//       //   $('.arch-container').addClass('hidden');
//       //   $('.arch-container').removeClass('fade-out');
//       //   $('#physician-arch-container').removeClass('hidden fade-in fade-out');
//       //   $('#physician-arch-text').slideToggle();
//       // }, 4500);
//       setTimeout(function() {
//         $('#physician-arch-text').slideToggle();
//       }, 500);
//     }

//     //first arch is selected
//     if(selected_class.includes('arch-3')) {
//       // setTimeout(function() {
//       //   $('.arch-item').removeClass('fade-out active');
//       //   $('#patient-arch-container').addClass('fade-in');
//         //hide all other arch containers
//       // }, 3000);
//       // setTimeout(function(){
//       //   $('.arch-container').addClass('hidden');
//       //   $('.arch-container').removeClass('fade-out');
//       //   $('#patient-arch-container').removeClass('hidden fade-in fade-out');
//       //   $('#patient-arch-text').slideToggle();
//       // }, 4500);
//       setTimeout(function() {
//         $('#patient-arch-text').slideToggle();
//       }, 500);
//     }
//   });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js